<template>
  <el-container>
    <el-header>
      <index-header />
    </el-header>
    <el-main>
      <div class="main">
        <router-view></router-view>
      </div>
    </el-main>
    <el-footer>
      <base-footer />
    </el-footer>
  </el-container>
</template>
<script>
import IndexHeader from "./IndexHeader.vue";
import BaseFooter from "./BaseFooter.vue";
export default {
  components: {
    IndexHeader,
    BaseFooter,
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.el-header {
  width: 100%;
  height: 76px !important;
  padding: 0;
  background: #619aff linear-gradient(90deg, #2c6cd6 0%, #898afe 100%);
  background-color: #619aff;
  // 兼容
  background-image: -moz-linear-gradient(90deg, #2c6cd6 0%, #898afe 100%);
  background-image: -o-linear-gradient(90deg, #2c6cd6 0%, #898afe 100%);
  background-image: -webkit-gradient(90deg, #2c6cd6 0%, #898afe 100%);
  background-image: -webkit-linear-gradient(90deg, #2c6cd6 0%, #898afe 100%);
  background-image: -ms-linear-gradient(90deg, #2c6cd6 0%, #898afe 100%);
  background-image: linear-gradient(90deg, #2c6cd6 0%, #898afe 100%);
  box-shadow: 0 13px 39px 0 rgba(47, 95, 233, 0.5);
}
.el-main {
  padding: 0;
  background-color: #fff;
}
.el-footer {
  height: 580px !important;
  padding: 0;
  background-image: url("../../../src/assets/footer_bg.png");
  background-size: 100% 580px;
}
</style>
